<script setup>
import { computed } from 'vue';
import { useFieldErrors } from '@/composables/ruleEngine/useFieldErrors';

const props = defineProps({
    modelValue: {
        type: Object,
        default: () => ({
            min_per_application: null,
            max_per_application: null,
            min_solo_applicant: null,
            max_solo_applicant: null,
        }),
    },
    errors: { type: [Array, Object], default: () => ({}) },
});

const emit = defineEmits(['update:modelValue', 'touched']);

const model = computed({
    get: () => props.modelValue || {},
    set: (val) => emit('update:modelValue', val),
});

const { errorsFor } = useFieldErrors(props);

const setNumber = (key, value) => {
    emit('touched');

    let newValue = null;

    if (value !== '' && value !== null) {
        newValue = Number(value);
    }

    model.value = {
        ...model.value,
        [key]: newValue,
    };
};

const minPerApplication = computed({
    get: () => model.value.min_per_application ?? '',
    set: (val) => setNumber('min_per_application', val),
});

const maxPerApplication = computed({
    get: () => model.value.max_per_application ?? '',
    set: (val) => setNumber('max_per_application', val),
});

const minSoloApplicant = computed({
    get: () => model.value.min_solo_applicant ?? '',
    set: (val) => setNumber('min_solo_applicant', val),
});

const maxSoloApplicant = computed({
    get: () => model.value.max_solo_applicant ?? '',
    set: (val) => setNumber('max_solo_applicant', val),
});
</script>

<template>
<div>
    <p class="font-semibold mb-3">
        {{ $t('label.gbc_score_rule_title') }}
    </p>

    <div class="grid md:grid-cols-2 gap-4">
        <StyledInput
            v-model="minPerApplication"
            :label="$t('label.gbc_min_per_application')"
            name="min_per_application"
            type="number"
            :error-messages="errorsFor('min_per_application')" />

        <StyledInput
            v-model="maxPerApplication"
            :label="$t('label.gbc_max_per_application')"
            name="max_per_application"
            type="number" 
            :error-messages="errorsFor('max_per_application')" />

        <StyledInput
            v-model="minSoloApplicant"
            :label="$t('label.gbc_min_solo_applicant')"
            name="min_solo_applicant"
            type="number"
            :error-messages="errorsFor('min_solo_applicant')" />

        <StyledInput
            v-model="maxSoloApplicant"
            :label="$t('label.gbc_max_solo_applicant')"
            name="max_solo_applicant"
            type="number" 
            :error-messages="errorsFor('max_solo_applicant')" />
    </div>
</div>
</template>
